
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import PianoCustomerStateHandler from '@piano/components/PianoCustomerStateHandler.vue';
import ArticleAuthorList from '@root/modules/article/components/authors/ArticleAuthorList.vue';
import ArticleInfoSources from '@root/modules/article/components/info/ArticleInfoSources.vue';
import ArticleInfoSocial from '@root/modules/article/components/info/ArticleInfoSocial.vue';
import ArticleInfoPaywallDisableCoundown from '@root/modules/article/components/info/ArticleInfoPaywallDisableCountdown.vue';

interface Props {
  article: ArticleData;
  size: string;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    ArticleAuthorList,
    ArticleInfoSources,
    ArticleInfoSocial,
    ArticleInfoPaywallDisableCoundown,
    PianoCustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
  },
});
